module.exports = __webpack_public_path__ + "img/broadcast-tiao-icon6.9834325d.png";